import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Box, Button } from '@material-ui/core';
import { isMobile, isIOS, isMobileSafari, isIOS13, isIPhone13, isIPad13 } from 'react-device-detect';
import { ScreenContainer, ScreenNavigation } from '../../screens/common';
import { OnScreenKeyboard } from '../common';
import { staticImages } from '../../../assets/static-images';
import { instructionVideos } from '../../../assets/instruction-videos';
import videojs from 'video.js';
import "video.js/dist/video-js.min.css";

class InstructionVideo extends Component {
	constructor(props) {
		super(props);

		this.state = {
			videoEnded: false
		};

		this.handlePlay = this.handlePlay.bind(this);
		this.handleNext = this.handleNext.bind(this);
	}

	componentDidMount() {
		this.player = videojs(this.videoNode, {
			autoplay: false,
			controls: false,
			preload: 'auto',
			fluid: true,
			responsive: true,
			sources: [{
				src: instructionVideos[this.props.instructions],
				type: 'video/mp4'
			}]
		});

		this.player.on('click', () => {
			if (this.player.paused()) {
				this.player.play();
			} else {
				this.player.pause();
			}
		});

		this.player.on('ended', () => {
			this.setState({videoEnded: true});
		});
	}

	componentWillUnmount() {
		if (this.player) {
			this.player.dispose()
		}
	}

	handlePlay() {
		if (this.player.paused()) {
			this.player.play();
		} else {
			this.player.pause();
		}
	}

	handleNext() {
		const { history, nextLink, saveScreenDuration } = this.props;
		saveScreenDuration();
		history.push(nextLink);
	}

	isIpadOS() {
		return (('ontouchstart' in window) || (navigator.maxTouchPoints > 0)) && (/Macintosh/).test(navigator.userAgent);
	}

	render() {
		return (
			<ScreenContainer>
				{(isMobile || isIOS || isMobileSafari || isIOS13 || isIPhone13 || isIPad13 || this.isIpadOS()) ? <OnScreenKeyboard handleKeydown={this.props.handleMobileKeydown} /> : ''}
				<Box className="box-container">
					<Box className="video-box">
						<div data-vjs-player>
							<video ref={ node => this.videoNode = node } className="video-js" playsInline></video>
						</div>
						<Button className="video-play-button" onClick={this.handlePlay}>
							<img width="161" height="161" src={staticImages.playButton} alt="Play Button" />
						</Button>
					</Box>
				</Box>
				{this.state.videoEnded && <ScreenNavigation type="next" onClick={this.handleNext} />}
			</ScreenContainer>
		);
	}
}

const mapStateToProps = state => ({
	data: state.data
});

export default connect(mapStateToProps, null)(InstructionVideo);
